import React from 'react';
import { Link } from 'react-router-dom';

const Paginate = ({ pages, page, isAdmin = false, keyword = '', category = '' }) => {
  if (pages <= 1) return null;

  // Generate array of page numbers
  const pageNumbers = [...Array(pages).keys()].map((x) => x + 1);

  return (
    <div className="flex justify-center mt-4">
      <ul className="flex space-x-1">
        {/* Previous button */}
        {page > 1 && (
          <li>
            <Link
              to={
                !isAdmin
                  ? keyword
                    ? `/search/${keyword}/page/${page - 1}`
                    : category
                    ? `/category/${category}/page/${page - 1}`
                    : `/page/${page - 1}`
                  : `/admin/productlist/${page - 1}`
              }
              className="px-3 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
            >
              <i className="fas fa-chevron-left"></i>
            </Link>
          </li>
        )}

        {/* Page numbers */}
        {pageNumbers.map((x) => (
          <li key={x}>
            <Link
              to={
                !isAdmin
                  ? keyword
                    ? `/search/${keyword}/page/${x}`
                    : category
                    ? `/category/${category}/page/${x}`
                    : `/page/${x}`
                  : `/admin/productlist/${x}`
              }
              className={`px-3 py-2 rounded-md ${
                x === page
                  ? 'bg-primary text-white'
                  : 'border border-gray-300 text-gray-700 hover:bg-gray-100'
              }`}
            >
              {x}
            </Link>
          </li>
        ))}

        {/* Next button */}
        {page < pages && (
          <li>
            <Link
              to={
                !isAdmin
                  ? keyword
                    ? `/search/${keyword}/page/${page + 1}`
                    : category
                    ? `/category/${category}/page/${page + 1}`
                    : `/page/${page + 1}`
                  : `/admin/productlist/${page + 1}`
              }
              className="px-3 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
            >
              <i className="fas fa-chevron-right"></i>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Paginate;
